require "./views/admin_header_view"
require "./admin_router"

if $('body').hasClass('administration')
  
  $(document).ready ->
    Extranet.adminHeaderView = new Extranet.Views.AdminHeaderView()
    Extranet.adminRouter = new Extranet.Routers.AdminRouter
    Backbone.history.start()
